import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/baseApi.client';
interface ChallengeStartMutationRequest {
  id: number;
}
interface ChallengeStartMutationResponse {
  success: boolean;
  message?: string;
  challengeStarted?: boolean;
}
export const useChallengeStartMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export type { ChallengeStartMutationRequest, ChallengeStartMutationResponse };
async function _temp(t0) {
  const {
    id
  } = t0;
  ;
  try {
    const response = await api.post(`/api/challenges/${id}/start`);
    return response.data;
  } catch (t1) {
    const error = t1;
    console.error("Failed to start challenge:", error);
    return {
      success: false,
      message: "Failed to start challenge"
    };
  }
}